import { FC } from 'react';
import BronzeTierIcon from './BronzeTierIcon';
import PlatinumTierIcon from './PlatinumTierIcon';
import PhenomTierIcon from './PhenomTierIcon';
import GoldTierIcon from './GoldTierIcon';
import SilverTierIcon from './SilverTierIcon';

export interface TierIconProps {
  className?: string;
  color?: string;
  onClick?: () => void;
  tier?: number;
}

const TierIcon: FC<TierIconProps> = ({ tier, ...props }) => {
  switch (tier) {
    case 1:
      return <SilverTierIcon {...props} />;
    case 2:
      return <GoldTierIcon {...props} />;
    case 3:
      return <PlatinumTierIcon {...props} />;
    case 4:
      return <PhenomTierIcon {...props} />;
    default:
      return <BronzeTierIcon {...props} />;
  }
};

export default TierIcon;
